import { useContext } from 'react';
import { DocsPageContext } from '../contexts/docsPageContext';

export const useDocsPageContext = () => useContext(DocsPageContext);
